export const validate = ({
  name,
  orderType,
  selectedStrata,
  selectedStrataCert 
}) => {
  var error = null;
  var errors = {};

  if (orderType === 'STRATA_SEARCH') {
    if (!selectedStrata) {
      error = 'You must select a Strata Management'
    } else if (!selectedStrataCert) {
      error = 'You must select a Strata Certificate'
    }
  }

  if (selectedStrata && selectedStrata.is_other) {
    if (!name) {
      error = 'Please provide a strata name when selecting "Other"';
      errors.name = 'You must provide a strata name';
    }
  }

  return [!Object.getOwnPropertyNames(errors).length, errors, error];
};

export default validate;
